import { memo } from 'react';
import { IconTag } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import type { AddSegmentUploadViewProps } from './types';
import VideoPreviewForInsert from './VideoPreviewForInsert';
import FilesInput from '@/components/atoms/inputs/FilesInput/FilesInput';
import Icon from '@/components/atoms/Icon';

const SUPPORTED_TYPES = '.mp4,.mov';

function AddSegmentUploadView({
  onClose,
  clipIntroOutro,
  brandKitIntroOutro,
  brandKitStore,
  uploadFiles,
  onFilesUpload,
  handleVideoSelect,
  deleteItem,
  removedBrandKitName
}: AddSegmentUploadViewProps) {
  return (
    <>
      <div className="flex w-full flex-col items-center justify-center !text-slate-500">
        {!clipIntroOutro.length ? (
          <div className="h-36 w-full">
            <FilesInput
              onFilesUpload={uploadFiles}
              accept={SUPPORTED_TYPES}
              title="Upload a file"
              label="Click to browse, or drag & drop a file here"
              icon="IconUpload"
            />
          </div>
        ) : (
          <div className="grid w-full grid-cols-2 gap-2">
            {clipIntroOutro.map(video => (
              <VideoPreviewForInsert
                url={video.url}
                onSelect={handleVideoSelect}
                onDelete={video.name === removedBrandKitName ? undefined : () => deleteItem(video.name)}
                onClose={onClose}
                key={video.url}
              />
            ))}
            <div className="aspect-video">
              <FilesInput onFilesUpload={onFilesUpload} accept={SUPPORTED_TYPES} label="" icon="IconUpload" />
            </div>
          </div>
        )}
      </div>
      <div className="mt-[14px]">
        <div className="flex items-center gap-1">
          <Icon name="IconMovie" className="size-3" />
          <div className="text-[13px] font-medium">Brand Intro/Outro</div>
        </div>
        {brandKitStore.intro_outro.length ? (
          <div className="mt-2 grid w-full grid-cols-2 gap-2">
            {brandKitIntroOutro.map(video => (
              <VideoPreviewForInsert url={video} onSelect={handleVideoSelect} onClose={onClose} key={video} />
            ))}
          </div>
        ) : (
          <div className="mt-1.5 flex w-full items-center justify-center space-x-2 rounded-md bg-slate-100 py-5 text-center text-xs text-slate-500">
            <IconTag className="size-4" />
            <span>
              Upload branded videos in{' '}
              <Link to="/brand-kit" className="underline hover:no-underline">
                Brand Kit
              </Link>
            </span>
          </div>
        )}
      </div>
    </>
  );
}

export default memo(AddSegmentUploadView);
